export default __webpack_public_path__ + "static/media/graduationCap.e5251cd5.png";